'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { memoize } from 'underscore';
import { isBelowMinimumRequiredReviews } from '../../utils/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIconRating from 'UIComponents/input/UIIconRating';
import UIFlex from 'UIComponents/layout/UIFlex';
var RATING_ICON_SIZE = 'xxs';
var getI18nKey = memoize(function (path) {
  return "MarketplaceUI.goodDetailsPage." + path;
});

var GoodRatingInfo = /*#__PURE__*/function (_PureComponent) {
  _inherits(GoodRatingInfo, _PureComponent);

  function GoodRatingInfo() {
    _classCallCheck(this, GoodRatingInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(GoodRatingInfo).apply(this, arguments));
  }

  _createClass(GoodRatingInfo, [{
    key: "render",
    value: function render() {
      var goodDetails = this.props.goodDetails;
      var reviewsCount = goodDetails.get('reviews').size;
      var renderedRating;

      if (isBelowMinimumRequiredReviews(reviewsCount)) {
        renderedRating = React.createElement(FormattedMessage, {
          message: getI18nKey('reviews.noRatings')
        });
      } else {
        renderedRating = [React.createElement(UIIconRating, {
          key: "rating",
          disabled: true,
          size: RATING_ICON_SIZE,
          showPercentage: true,
          value: goodDetails.get('averageRating')
        }), React.createElement("span", {
          key: "reviews",
          className: "m-left-2"
        }, "(", reviewsCount, ")")];
      }

      return React.createElement(UIFlex, {
        align: "center",
        className: "m-left-4"
      }, renderedRating);
    }
  }]);

  return GoodRatingInfo;
}(PureComponent);

GoodRatingInfo.propTypes = {
  goodDetails: PropTypes.instanceOf(Immutable.Map).isRequired
};
export default GoodRatingInfo;